import {API_DATE_FORMAT} from '@coveo/headless';

export function parseDate(date: Date | string, format?: string) {
  if (!format) {
    format = API_DATE_FORMAT;
  }
  let parsedDate;
  if (date instanceof Date) {
    parsedDate = date;
  } else {
    parsedDate = new Date(date);
  }
  if (!parsedDate.toString().includes('Invalid')) {
    return parsedDate;
  }
  return new Date(date);
}

export function formatEventDates(language: string, startDate?: Date | string, endDate?: Date | string, format?: string) {
  if (!startDate) {
    return;
  }

  const fullDateOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  const fullDateFormatter = new Intl.DateTimeFormat(language, fullDateOptions);
  const parsedStartDate = parseDate(startDate, format);
  if (!endDate) {
    return fullDateFormatter.format(parsedStartDate);
  }

  const parsedEndDate = parseDate(endDate, format);

  if(parsedStartDate.toDateString() === parsedEndDate.toDateString()) {
    return fullDateFormatter.format(parsedStartDate);
  }

  const monthDayOptions: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric'
  };
  const monthDayFormatter = new Intl.DateTimeFormat(language, monthDayOptions);

  if (parsedStartDate.getMonth() === parsedEndDate.getMonth() && parsedStartDate.getFullYear() === parsedEndDate.getFullYear()) {
    return `${monthDayFormatter.format(parsedStartDate)}-${parsedEndDate.getDate()}, ${parsedEndDate.getFullYear()}`;
  }
  
  return `${fullDateFormatter.format(parsedStartDate)} - ${fullDateFormatter.format(parsedEndDate)}`;
}